

export function hasFlag<T extends number>(valueToTest: T, flag: T): boolean {
    return (valueToTest & flag) === flag;
}

export function addFlag<T extends number>(existingValue: T, flag: T): T {
    return <T>(existingValue | flag);
}

